var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90002 2H16.9C20.4 2 21.9 4 21.9 7V17C21.9 20 20.4 22 16.9 22H8.90002C5.40002 22 3.90002 20 3.90002 17V7C3.90002 4 5.40002 2 8.90002 2ZM11.83 15.49C12.34 17.12 14.13 17.97 14.63 17.97C15.12 17.96 16.89 17.13 17.42 15.49C17.75 14.46 17.36 13.19 16.29 12.84C15.72 12.66 15.02 12.81 14.63 13.36C14.26 12.79 13.53 12.66 12.97 12.84C11.89 13.19 11.51 14.46 11.83 15.49ZM6.40002 9.25H8.40002C9.92002 9.25 11.15 8.02 11.15 6.5V4.5C11.15 4.09 10.81 3.75 10.4 3.75C9.99002 3.75 9.65002 4.09 9.65002 4.5V6.5C9.65002 7.19 9.09002 7.75 8.40002 7.75H6.40002C5.99002 7.75 5.65002 8.09 5.65002 8.5C5.65002 8.91 5.99002 9.25 6.40002 9.25Z",
    fill: "url(#paint0_linear_5984_4946)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5984_4946",
    x1: 12.9,
    y1: 2,
    x2: 12.9,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFav);
export default __webpack_public_path__ + "static/media/activeFav.37a742201b134546f425e7f8e8cd9767.svg";
export { ForwardRef as ReactComponent };